<template>
    <el-image
            :preview-src-list="srcList"
            :src="url">
    </el-image>
</template>

<script>
    export default {
        name: 'imgViewer',
        data() {
            return {
                url: this.$route.query.file,
                srcList: [this.$route.query.file]
            }
        },
        created() {
            this.$store.dispatch('hideLoadingBar');
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {}
    }
</script>

<style scoped>

</style>
